import createReducer from "rdx/utils/createReducer";

const initialState = {};

export default {
  earnings: createReducer(initialState, {
    // INSERTION_PT (for script, do not remove)
  }),
};
